import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import { ChartTooltip } from './ChartTooltip';
import { fmtInt, fmtPct } from '@/lib/format';

const COLORS = ['var(--tenant-accent-500)', '#0E9F6E', '#E9D7A8', '#5B6472', '#2563EB'];

export const AgeDonut = ({ data = [], height = 260 }) => {
  const chartData = data.map((d) => ({ name: d.label, value: d.count, pct: d.pct }));
  const total = chartData.reduce((s, d) => s + d.value, 0);
  return (
    <div className="flex flex-col items-center gap-4 sm:flex-row">
      <div style={{ height, width: '100%', maxWidth: 260 }}>
        <ResponsiveContainer width="100%" height="100%" minWidth={0}>
          <PieChart>
            <Pie data={chartData} dataKey="value" nameKey="name" innerRadius="58%" outerRadius="85%" paddingAngle={2} stroke="none">
              {chartData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip content={<ChartTooltip formatter={(v) => `${fmtInt(v)} BS`} />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid w-full grid-cols-1 gap-2">
        {chartData.map((d, i) => (
          <div key={i} className="flex items-center gap-2 text-sm">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
            <span className="text-muted-foreground">{d.name}</span>
            <span className="ml-auto font-medium tabular">{fmtPct(d.pct)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
